/** Loading placeholder — keeps layout stable while a resource is fetched. */
export default function Skeleton({ className = "", style, dark = false }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded-md ${
        dark ? "bg-white/10" : "bg-black/[0.06]"
      } ${className}`}
      style={style}
    />
  );
}
